export default {
	GET_ALL: (crewId) => `/houseItem/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseItem?crewId=${crewId}`,
	UPDATE: () => "/houseItem",
	DELETE: (id) => `/houseItem/${id}`,
	GET_NEXT: (crewId) => `/houseItem/next?crewId=${crewId}`,
	GET_PURCHASE_AVERAGE: (id, crewId) => `/houseItem/${id}/purchase-average?crewId=${crewId}`,
};
